import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, IDropdown, ResponsiveMode } from 'office-ui-fabric-react/lib/Dropdown';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { ComboBox, Spinner } from 'office-ui-fabric-react/lib/index';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import { Label } from 'reactstrap';
import { IModalDialog } from '../../../models/IModalDialog';
import { IPTONames } from '../../../models/IPTONames';
import { IAgentTermsServicesProps } from './IAgentTermsServicesProps';
import { IAgentTermsServicesState } from './IAgentTermsServicesState';
initializeIcons();

const textbox = mergeStyles({
    display: "inline-block",
    minWidth: '50px'
});
const textboxS = mergeStyles({
    display: "inline-block",
    minWidth: '50px'
});
const tableTechnical = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    verticalAlign: "bottom",
    padding: "5px"
});
const panelDisabled = mergeStyles({
    display: 'block',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%",
    fontSize: "12px",
    color: '#005269',
    pointerEvents: "none"
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    tableLayout: "fixed"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269",
    backgroundColor: '#35AFD1', color: "#ffffff"
});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell", fontSize: '12px', padding: "2px"
});
const responsiveTableBodyCaption = mergeStyles({
    width: "100%", overflow: "auto", fontSize: '13px', background: '#E5E5E5', padding: "5px"
});
const responsiveTableBodyCellText = mergeStyles({
    width: "100%", overflow: "auto", alignContent: 'justify', padding: "5px"
});
const responsiveTableHeaderCell = mergeStyles({
    textAlign: "center", backgroundColor: "#35AFD1", color: "#FFFFFF", width: "100%", padding: "5px"
});
const textboxWithDropdown = mergeStyles({
    display: "inline-block",
    marginRight: "5px"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
const dropdownStyle = mergeStyles({ minWidth: '150px', fontSize: "12px" });
export default class AgentTermsServices extends React.Component<IAgentTermsServicesProps, IAgentTermsServicesState>
{
    private dialog: IModalDialog;
    constructor(props: IAgentTermsServicesProps, state: IAgentTermsServicesState) {
        super(props);
        this.state = {
            loading: false,
            isActive: false,
            isBussChecked: false,
            isTermsChecked: false,
            agentMaster: this.props.agentMaster,
            inputError: 'This field is required',
            showError: false,
            isValidData: true,
            saving: false,
            Currencies: [],
            terms: this.props.terms,
            hideModel: true,
            technicalCompetence: [],
            ptonames: [],
            hideDialog: true
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async componentDidMount() {
        if (this.state.agentMaster.id !== null && this.state.agentMaster.id !== undefined && this.state.agentMaster.id !== "") {
            this.loadCurrencies();
            this.setState((prevState: IAgentTermsServicesState): IAgentTermsServicesState => {
                if (this.props.terms.id !== "" && this.props.terms.id !== undefined && this.props.terms.id !== null) {
                    prevState.terms = this.props.terms;
                    this.props.terms.ptoNames.forEach((item: IPTONames) => {
                        prevState.ptonames.push({ id: item.id, agentId: item.agentId, ptoName: item.ptoName });
                    });
                }
                return prevState;
            });
        }
    }
    public render(): React.ReactElement<IAgentTermsServicesProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const dropdownRef = React.createRef<IDropdown>();
        const techChemistry = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Chemistry").sort((a, b) => a.title > b.title ? 1 : -1);
        const techInstruments = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Instruments").sort((a, b) => a.title > b.title ? 1 : -1);
        const techElectricalengineering = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Electrical engineering").sort((a, b) => a.title > b.title ? 1 : -1);
        const techMechanicalengineering = this.state.terms.technicalCompetenceAgent.filter(tech => tech.category === "Mechanical engineering").sort((a, b) => a.title > b.title ? 1 : -1);
        let { ptonames } = this.state;
        return (
            <div className={panelDisabled}>
                {
                    (this.state.saving) && (
                        <div>
                            <div>
                                <Spinner label="Please wait..." />
                            </div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideDialog}
                                    dialogContentProps={{
                                        type: DialogType.largeHeader,
                                        title: this.dialog.dialogMessage,
                                    }}
                                    maxWidth="1024px"
                                    closeButtonAriaLabel="Close"
                                >
                                    <div>
                                        <div>
                                            <Label> {this.dialog.dialogBody} </Label>
                                        </div>
                                    </div>
                                    <DialogFooter>
                                        <DefaultButton onClick={this.closeMessagePopup} data-automation-id="test" text="Ok" disabled={false}
                                            className={submitButton} iconProps={{ iconName: "CheckMark" }} />
                                    </DialogFooter>
                                </Dialog>

                            </div>
                        </div>)
                }
                {
                    (!this.state.saving) && (
                        <div className={responsiveMain}>
                            <div className={responsiveTable} >
                                <div className={responsiveTableBody}>
                                    <div className={responsiveTableHeaderRow}>
                                        <div className={responsiveTableHeaderCell}>
                                            <h6>Terms of services</h6></div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>1. AGENT NAME AND COUNTRY/JURISDICTION</div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Agent name</div>
                                                        <div className={responsiveTableBodyCell}> {((this.state.agentMaster.firmName === undefined || this.state.agentMaster.firmName === "" || this.state.agentMaster.firmName === null) ? "TEST1" : this.state.agentMaster.firmName)} </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Country/Jurisdiction</div>
                                                        <div className={responsiveTableBodyCell}>{((this.state.agentMaster.countryName === undefined || this.state.agentMaster.countryName === "" || this.state.agentMaster.countryName === null) ? "AL1" : this.state.agentMaster.countryName)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>2.	OFFICE LOCATIONS OF YOUR FIRM</div>
                                    <div className={responsiveTableBodyCellText}>
                                        2.1 Indicate where your firm have offices in the country mentioned above under paragraph 1, and please underline your main office. If you don’t have local presence in this country, please indicate the location of the office which is intended to serve Zacco in IP-matters in this country/jurisdiction.
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>City</div>
                                                        <div className={responsiveTableBodyCell}>{((this.state.agentMaster.city === undefined || this.state.agentMaster.city === "" || this.state.agentMaster.city === null) ? "TEST1" : this.state.agentMaster.city)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Country</div>
                                                        <div className={responsiveTableBodyCell}>{((this.state.agentMaster.countryName === undefined || this.state.agentMaster.countryName === "" || this.state.agentMaster.countryName === null) ? "TEST" : this.state.agentMaster.countryName)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>3.	SIZE OF YOUR FIRM</div>
                                    <div className={responsiveTableBodyCellText}>
                                        3.1 Indicate the size of your firm in the country mentioned above under paragraph 1:
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Number of employees</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.employees.toString()} maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Number of patent attorneys/agents</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.patentAttorneys.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Number of trademark attorneys/agents</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.trademarkAttorneys.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Number of attorneys at law</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.lawAttorneys.toString()}
                                                            maxLength={6} /> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>4.	CAPACITY OF YOUR FIRM</div>
                                    <div className={responsiveTableBodyCellText}>
                                        4.1 Indicate the capacity of your firm in the country mentioned above under paragraph 1:
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>National patents within your jurisdictions filed last year</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.rpaLastYear.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Patent applications filed under the PCT last year</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.papctLastYear.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>National trademark applications within your jurisdictions filed last year</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.rtaLastYear.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Trademark applications filed under the Madrid Agreement last year (if applicable)
                                                        </div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.tamaLastYear.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>5.	RANKING AND REWARDS</div>
                                    <div className={responsiveTableBodyCellText}>
                                        5.1 Indicate your latest ranking according to the Managing IP magazine:
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Trademark prosecution</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.tradeProsecRank.toString()}
                                                            maxLength={6} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Patent prosecution</div>
                                                        <div className={responsiveTableBodyCell}><TextField required className={textbox} value={this.state.terms.patentProsecRank.toString()}
                                                            maxLength={6} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCellText}>
                                                            5.2 Have you received any other rewards the past year?
                                                        </div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <Stack tokens={stackTokens} verticalAlign="end">
                                                                <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                    <Dropdown
                                                                        id="ddrew"
                                                                        placeHolder="--Select--"
                                                                        componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                        options={[
                                                                            { key: 'Yes', text: 'Yes' },
                                                                            { key: 'No', text: 'No' }
                                                                        ]}
                                                                        required={true}
                                                                        styles={{ dropdown: { minWidth: 100 } }}
                                                                        selectedKey={this.state.terms.anyOtherAward}
                                                                    />
                                                                </Stack>
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>6.	INDEMNITY INSURANCE</div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable} >
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Do you have indemnity insurance (with a reputable insurance company)?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <Stack tokens={stackTokens} verticalAlign="end">
                                                                <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                    <Dropdown
                                                                        id="ddins"
                                                                        placeHolder="--Select--"
                                                                        componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                        options={[
                                                                            { key: 'Yes', text: 'Yes' },
                                                                            { key: 'No', text: 'No' }
                                                                        ]}
                                                                        required={true}
                                                                        styles={{ dropdown: { minWidth: 100 } }}
                                                                        selectedKey={this.state.terms.indemnityInsurance}
                                                                    />
                                                                </Stack>
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>If yes, please indicate maximum amount and currency per claim</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <div className={textboxWithDropdown}><TextField className={textbox} value={this.state.terms.iMaxAmount.toString()}
                                                                maxLength={10} />
                                                            </div>
                                                            <div className={textboxWithDropdown}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <ComboBox
                                                                            placeholder="-Currency--"
                                                                            allowFreeform
                                                                            autoComplete="on"
                                                                            options={this.state.Currencies}
                                                                            selectedKey={this.state.terms.iCurrency}
                                                                            className={dropdownStyle}
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Annual aggregate</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <div className={textboxWithDropdown}><TextField className={textbox} value={this.state.terms.iAnnualAggregate.toString()}
                                                                maxLength={10} />
                                                            </div>
                                                            <div className={textboxWithDropdown}>
                                                                <Stack tokens={stackTokens} verticalAlign="end">
                                                                    <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                        <ComboBox
                                                                            placeholder="-Currency--"
                                                                            allowFreeform
                                                                            autoComplete="on"
                                                                            options={this.state.Currencies}
                                                                            selectedKey={this.state.terms.aaCurrency}
                                                                            className={dropdownStyle}
                                                                        />
                                                                    </Stack>
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>7.	TECHNICAL COMPETENCE</div>
                                    <div className={responsiveTableBodyCellText}>
                                        7.1 In what following areas do you have technical competencies?
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCell}>
                                                        <div className={responsiveTableBodyCaption}>Chemistry</div>
                                                        <div className={tableTechnical}>
                                                            <div className={responsiveTableBody}>
                                                                {
                                                                    techChemistry.map((tech, i) => {
                                                                        return (
                                                                            <div className={responsiveTableRow}>
                                                                                <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} /></div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={responsiveTableBodyCell}>
                                                        <div className={responsiveTableBodyCaption}>Electrical engineering</div>
                                                        <div className={tableTechnical}>
                                                            <div className={responsiveTableBody}>
                                                                {
                                                                    techElectricalengineering.map((tech, i) => {
                                                                        return (
                                                                            <div className={responsiveTableRow}>
                                                                                <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} /></div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={responsiveTableBodyCell}>
                                                        <div className={responsiveTableBodyCaption}>Instruments</div>
                                                        <div className={tableTechnical}>
                                                            <div className={responsiveTableBody}>
                                                                {
                                                                    techInstruments.map((tech, i) => {
                                                                        return (
                                                                            <div className={responsiveTableRow}>
                                                                                <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} /></div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={responsiveTableBodyCell}>
                                                        <div className={responsiveTableBodyCaption}>Mechanical engineering</div>
                                                        <div className={tableTechnical}>
                                                            <div className={responsiveTableBody}>
                                                                {
                                                                    techMechanicalengineering.map((tech, i) => {
                                                                        return (
                                                                            <div className={responsiveTableRow}>
                                                                                <div className={responsiveTableBodyCell}>{tech.title}</div>
                                                                                <div className={responsiveTableBodyCell}><input value={tech.title} type="checkbox" checked={tech.selected} /></div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>8.	REPRESENTATION</div>
                                    <div className={responsiveTableBodyCellText}>
                                        8.1 In your capacity as attorney or agent, please indicate which patent and trademark offices (PTOs) you are allowed to prosecute applications before.
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            {
                                                ptonames.map((val, idx) => {
                                                    return (
                                                        <div>
                                                            <div key={idx} className={textboxWithDropdown}>
                                                                <label> Name of the PTO #{idx + 1} </label>
                                                            </div>
                                                            <div key={idx} className={textboxWithDropdown}>
                                                                <input type="text" data-id={idx} value={val.ptoName} />
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>9.	QUALITY MANAGEMENT SYSTEM</div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Do you have a quality management system implemented?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <Stack tokens={stackTokens} verticalAlign="end">
                                                                <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                    <Dropdown
                                                                        id="ddqty"
                                                                        placeHolder="--Select--"
                                                                        componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                        options={[
                                                                            { key: 'Yes', text: 'Yes' },
                                                                            { key: 'No', text: 'No' }
                                                                        ]}
                                                                        required={true}
                                                                        styles={{ dropdown: { minWidth: 100 } }}
                                                                        selectedKey={this.state.terms.qtyMgmt}
                                                                    />
                                                                </Stack>
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>If yes, which standard(s) does it comply with?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <TextField className={textboxS} value={this.state.terms.qtyMgmtStd}
                                                                maxLength={40} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>10.	IT &amp; INFORMATION SECURITY</div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Have you implemented a structured way of working with IT &amp; information security?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <Stack tokens={stackTokens} verticalAlign="end">
                                                                <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                    <Dropdown
                                                                        id="dditsec"
                                                                        placeHolder="--Select--"
                                                                        componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                        options={[
                                                                            { key: 'Yes', text: 'Yes' },
                                                                            { key: 'No', text: 'No' }
                                                                        ]}
                                                                        required={true}
                                                                        styles={{ dropdown: { minWidth: 100 } }}
                                                                        selectedKey={this.state.terms.itSec}
                                                                    />
                                                                </Stack>
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>If yes, which standard(s) does it comply with?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <TextField className={textboxS} value={this.state.terms.itSecStd}
                                                                maxLength={40} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>11.	CODE OF CONDUCT</div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Are you bound to any code(s) of professional conduct?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <Stack tokens={stackTokens} verticalAlign="end">
                                                                <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                                    <Dropdown
                                                                        id="ddprofcon"
                                                                        placeHolder="--Select--"
                                                                        componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                        options={[
                                                                            { key: 'Yes', text: 'Yes' },
                                                                            { key: 'No', text: 'No' }
                                                                        ]}
                                                                        required={true}
                                                                        styles={{ dropdown: { minWidth: 100 } }}
                                                                        selectedKey={this.state.terms.profConduct}
                                                                    />
                                                                </Stack>
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>If yes, please indicate which code(s).</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <TextField className={textboxS} value={this.state.terms.conductCodes}
                                                                maxLength={40} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={responsiveTableBodyCaption}>12.	DOCKETING SYSTEM (IP MANAGEMENT TOOL)</div>
                                    <div className={responsiveTableRow}>
                                        <div className={responsiveTableBodyCell}>
                                            <div className={responsiveTable}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableRow}>
                                                        <div className={responsiveTableBodyCell}>Which docketing system(s) do you use for case management?</div>
                                                        <div className={responsiveTableBodyCell}>
                                                            <TextField required className={textboxS} value={this.state.terms.docketingSystem}
                                                                maxLength={40} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private loadCurrencies(): void {
        this.setState((prevState: IAgentTermsServicesState): IAgentTermsServicesState => {
            var result: any = [];
            result.push(
                { key: 'AFN', text: 'AFN - Afghanistan Afghani' },
                { key: 'ALL', text: 'ALL - Albanian Lek' },
                { key: 'DZD', text: 'DZD - Algerian Dinar' },
                { key: 'USD', text: 'USD - US Dollar' },
                { key: 'EUR', text: 'EUR - Euro' },
                { key: 'AOA', text: 'AOA - Angolan Kwanza' },
                { key: 'XCD', text: 'XCD - East Caribbean Dollar' },
                { key: 'ARS', text: 'ARS - Argentine Peso' },
                { key: 'AMD', text: 'AMD - Armenian Dram' },
                { key: 'AWG', text: 'AWG - Aruban Guilder' },
                { key: 'AUD', text: 'AUD - Australian Dollar' },
                { key: 'AZN', text: 'AZN - Azerbaijan New Manat' },
                { key: 'BSD', text: 'BSD - Bahamian Dollar' },
                { key: 'BHD', text: 'BHD - Bahraini Dinar' },
                { key: 'BDT', text: 'BDT - Bangladeshi Taka' },
                { key: 'BBD', text: 'BBD - Barbados Dollar' },
                { key: 'BYR', text: 'BYR - Belarussian Ruble' },
                { key: 'BZD', text: 'BZD - Belize Dollar' },
                { key: 'XOF', text: 'XOF - CFA Franc BCEAO' },
                { key: 'BMD', text: 'BMD - Bermudian Dollar' },
                { key: 'BTN', text: 'BTN - Bhutan Ngultrum' },
                { key: 'BOB', text: 'BOB - Boliviano' },
                { key: 'BAM', text: 'BAM - Marka' },
                { key: 'BWP', text: 'BWP - Botswana Pula' },
                { key: 'NOK', text: 'NOK - Norwegian Krone' },
                { key: 'BRL', text: 'BRL - Brazilian Real' },
                { key: 'BND', text: 'BND - Brunei Dollar' },
                { key: 'BGN', text: 'BGN - Bulgarian Lev' },
                { key: 'BIF', text: 'BIF - Burundi Franc' },
                { key: 'CVE', text: 'CVE - Cape Verde Escudo' },
                { key: 'KHR', text: 'KHR - Kampuchean Riel' },
                { key: 'XAF', text: 'XAF - CFA Franc BEAC' },
                { key: 'CAD', text: 'CAD - Canadian Dollar' },
                { key: 'KYD', text: 'KYD - Cayman Islands Dollar' },
                { key: 'CLP', text: 'CLP - Chilean Peso' },
                { key: 'CNY', text: 'CNY - Yuan Renminbi' },
                { key: 'COP', text: 'COP - Colombian Peso' },
                { key: 'KMF', text: 'KMF - Comoros Franc' },
                { key: 'CDF', text: 'CDF - Francs' },
                { key: 'NZD', text: 'NZD - New Zealand Dollar' },
                { key: 'CRC', text: 'CRC - Costa Rican Colon' },
                { key: 'HRK', text: 'HRK - Croatian Kuna' },
                { key: 'CUP', text: 'CUP - Cuban Peso' },
                { key: 'CZK', text: 'CZK - Czech Koruna' },
                { key: 'DKK', text: 'DKK - Danish Krone' },
                { key: 'DJF', text: 'DJF - Djibouti Franc' },
                { key: 'DOP', text: 'DOP - Dominican Peso' },
                { key: 'ECS', text: 'ECS - Ecuador Sucre' },
                { key: 'EGP', text: 'EGP - Egyptian Pound' },
                { key: 'SVC', text: 'SVC - El Salvador Colon' },
                { key: 'ERN', text: 'ERN - Eritrean Nakfa' },
                { key: 'ETB', text: 'ETB - Ethiopian Birr' },
                { key: 'FKP', text: 'FKP - Falkland Islands Pound' },
                { key: 'FJD', text: 'FJD - Fiji Dollar' },
                { key: 'GMD', text: 'GMD - Gambian Dalasi' },
                { key: 'GEL', text: 'GEL - Georgian Lari' },
                { key: 'GHS', text: 'GHS - Ghanaian Cedi' },
                { key: 'GIP', text: 'GIP - Gibraltar Pound' },
                { key: 'GBP', text: 'GBP - Pound Sterling' },
                { key: 'XCD', text: 'XCD - East Carribean Dollar' },
                { key: 'QTQ', text: 'QTQ - Guatemalan Quetzal' },
                { key: 'GGP', text: 'GGP - Pound Sterling' },
                { key: 'GNF', text: 'GNF - Guinea Franc' },
                { key: 'GWP', text: 'GWP - Guinea-Bissau Peso' },
                { key: 'GYD', text: 'GYD - Guyana Dollar' },
                { key: 'HTG', text: 'HTG - Haitian Gourde' },
                { key: 'HNL', text: 'HNL - Honduran Lempira' },
                { key: 'HKD', text: 'HKD - Hong Kong Dollar' },
                { key: 'HUF', text: 'HUF - Hungarian Forint' },
                { key: 'ISK', text: 'ISK - Iceland Krona' },
                { key: 'INR', text: 'INR - Indian Rupee' },
                { key: 'IDR', text: 'IDR - Indonesian Rupiah' },
                { key: 'IRR', text: 'IRR - Iranian Rial' },
                { key: 'IQD', text: 'IQD - Iraqi Dinar' },
                { key: 'ILS', text: 'ILS - Israeli New Shekel' },
                { key: 'JMD', text: 'JMD - Jamaican Dollar' },
                { key: 'JPY', text: 'JPY - Japanese Yen' },
                { key: 'JOD', text: 'JOD - Jordanian Dinar' },
                { key: 'KZT', text: 'KZT - Kazakhstan Tenge' },
                { key: 'KES', text: 'KES - Kenyan Shilling' },
                { key: 'KPW', text: 'KPW - North Korean Won' },
                { key: 'KRW', text: 'KRW - Korean Won' },
                { key: 'KWD', text: 'KWD - Kuwaiti Dinar' },
                { key: 'KGS', text: 'KGS - Som' },
                { key: 'LAK', text: 'LAK - Lao Kip' },
                { key: 'LVL', text: 'LVL - Latvian Lats' },
                { key: 'LBP', text: 'LBP - Lebanese Pound' },
                { key: 'LSL', text: 'LSL - Lesotho Loti' },
                { key: 'LRD', text: 'LRD - Liberian Dollar' },
                { key: 'LYD', text: 'LYD - Libyan Dinar' },
                { key: 'CHF', text: 'CHF - Swiss Franc' },
                { key: 'LTL', text: 'LTL - Lithuanian Litas' },
                { key: 'MOP', text: 'MOP - Macau Pataca' },
                { key: 'MKD', text: 'MKD - Denar' },
                { key: 'MGF', text: 'MGF - Malagasy Franc' },
                { key: 'MWK', text: 'MWK - Malawi Kwacha' },
                { key: 'MYR', text: 'MYR - Malaysian Ringgit' },
                { key: 'MVR', text: 'MVR - Maldive Rufiyaa' },
                { key: 'MRO', text: 'MRO - Mauritanian Ouguiya' },
                { key: 'MUR', text: 'MUR - Mauritius Rupee' },
                { key: 'MXN', text: 'MXN - Mexican Nuevo Peso' },
                { key: 'MDL', text: 'MDL - Moldovan Leu' },
                { key: 'MNT', text: 'MNT - Mongolian Tugrik' },
                { key: 'MAD', text: 'MAD - Moroccan Dirham' },
                { key: 'MZN', text: 'MZN - Mozambique Metical' },
                { key: 'MMK', text: 'MMK - Myanmar Kyat' },
                { key: 'NAD', text: 'NAD - Namibian Dollar' },
                { key: 'NPR', text: 'NPR - Nepalese Rupee' },
                { key: 'ANG', text: 'ANG - Netherlands Antillean Guilder' },
                { key: 'XPF', text: 'XPF - CFP Franc' },
                { key: 'NIO', text: 'NIO - Nicaraguan Cordoba Oro' },
                { key: 'NGN', text: 'NGN - Nigerian Naira' },
                { key: 'OMR', text: 'OMR - Omani Rial' },
                { key: 'PKR', text: 'PKR - Pakistan Rupee' },
                { key: 'PAB', text: 'PAB - Panamanian Balboa' },
                { key: 'PGK', text: 'PGK - Papua New Guinea Kina' },
                { key: 'PYG', text: 'PYG - Paraguay Guarani' },
                { key: 'PEN', text: 'PEN - Peruvian Nuevo Sol' },
                { key: 'PHP', text: 'PHP - Philippine Peso' },
                { key: 'PLN', text: 'PLN - Polish Zloty' },
                { key: 'QAR', text: 'QAR - Qatari Rial' },
                { key: 'RON', text: 'RON - Romanian New Leu' },
                { key: 'RUB', text: 'RUB - Russian Ruble' },
                { key: 'RWF', text: 'RWF - Rwanda Franc' },
                { key: 'SHP', text: 'SHP - St. Helena Pound' },
                { key: 'WST', text: 'WST - Samoan Tala' },
                { key: 'STD', text: 'STD - Dobra' },
                { key: 'SAR', text: 'SAR - Saudi Riyal' },
                { key: 'RSD', text: 'RSD - Dinar' },
                { key: 'SCR', text: 'SCR - Seychelles Rupee' },
                { key: 'SLL', text: 'SLL - Sierra Leone Leone' },
                { key: 'SGD', text: 'SGD - Singapore Dollar' },
                { key: 'SBD', text: 'SBD - Solomon Islands Dollar' },
                { key: 'SOS', text: 'SOS - Somali Shilling' },
                { key: 'ZAR', text: 'ZAR - South African Rand' },
                { key: 'SSP', text: 'SSP - South Sudan Pound' },
                { key: 'LKR', text: 'LKR - Sri Lanka Rupee' },
                { key: 'SDG', text: 'SDG - Sudanese Pound' },
                { key: 'SRD', text: 'SRD - Surinam Dollar' },
                { key: 'SZL', text: 'SZL - Swaziland Lilangeni' },
                { key: 'SEK', text: 'SEK - Swedish Krona' },
                { key: 'SYP', text: 'SYP - Syrian Pound' },
                { key: 'TWD', text: 'TWD - Taiwan Dollar' },
                { key: 'TJS', text: 'TJS - Tajik Somoni' },
                { key: 'TZS', text: 'TZS - Tanzanian Shilling' },
                { key: 'THB', text: 'THB - Thai Baht' },
                { key: 'TOP', text: "TOP - Tongan Pa'anga" },
                { key: 'TTD', text: 'TTD - Trinidad and Tobago Dollar' },
                { key: 'TND', text: 'TND - Tunisian Dollar' },
                { key: 'TRY', text: 'TRY - Turkish Lira' },
                { key: 'TMT', text: 'TMT - Manat' },
                { key: 'UGX', text: 'UGX - Uganda Shilling' },
                { key: 'UAH', text: 'UAH - Ukraine Hryvnia' },
                { key: 'AED', text: 'AED - Arab Emirates Dirham' },
                { key: 'UYU', text: 'UYU - Uruguayan Peso' },
                { key: 'UZS', text: 'UZS - Uzbekistan Sum' },
                { key: 'VUV', text: 'VUV - Vanuatu Vatu' },
                { key: 'VEF', text: 'VEF - Venezuelan Bolivar' },
                { key: 'VND', text: 'VND - Vietnamese Dong' },
                { key: 'YER', text: 'YER - Yemeni Rial' },
                { key: 'ZMW', text: 'ZMW - Zambian Kwacha' },
                { key: 'ZWD', text: 'ZWD - Zimbabwe Dollar' }
            );
            prevState.Currencies = result;
            return prevState;
        });
    }
    private closeMessagePopup = (): void => {
        this.setState((previousState: IAgentTermsServicesState): IAgentTermsServicesState => {
            previousState.hideDialog = true;
            previousState.hideModel = true;
            previousState.isValidData = false;
            previousState.saving = false;
            return previousState;
        });
    }
}